import React, { useState } from "react";
import { Form, Input, Radio, Button, Modal, message } from "antd";
import "../../style.css";

const CreateForm = ({ handleAddMember, parseRoleId }) => {
  const [form] = Form.useForm();

  const formatDateOfCurrentTime = () => {
    const currentTime = new Date();
    currentTime.setHours(currentTime.getHours() + 8);

    return currentTime.toISOString().replace("T", " ").slice(0, 19);
  };

  const handleFinish = async (userInfo) => {
    Modal.confirm({
      title: "确认添加",
      content: (
        <div className="modal-content">
          <p>
            确认给学号为 <b>{userInfo.user_no}</b> 的同学
          </p>
          <p>
            授予权限 <b>{parseRoleId(userInfo.role_id)}</b>
          </p>
          <p>
            昵称: <b>{userInfo.nick_name}</b>
          </p>
          <p>
            手机号: <b>{userInfo.phone_no}</b>
          </p>
          <p>提交前请确认以上信息是否正确</p>
        </div>
      ),
      onOk() {
        const memberData = {
          phone_no: userInfo.phone_no,
          user_no: userInfo.user_no,
          nick_name: userInfo.nick_name,
          role_id: userInfo.role_id,
          password: userInfo.password,
          status: 1,
          is_deleted: 0,
          ctime: formatDateOfCurrentTime(),
          mtime: formatDateOfCurrentTime(),
        };
        handleAddMember(memberData, form);
      },
    });
  };

  return (
    <div
      style={{
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <div style={{ maxWidth: "600px", width: "100%" }}>
        <h2 style={{ textAlign: "center" }}>新增成员</h2>
        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Form.Item
              name="user_no"
              label="成员学号"
              rules={[
                { required: true, message: "请输入以BJ开头的9位学号" },
                {
                  pattern: /^BJ\d{7}$/,
                  message: "请输入BJ开头的9位学号",
                },
              ]}
              style={{ width: "100%" }}
            >
              <Input
                className="centered-input"
                placeholder="请输入学号"
                autoComplete="off"
              />
            </Form.Item>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Form.Item
              name="nick_name"
              label="成员昵称"
              rules={[{ required: true, message: "请输入成员昵称" }]}
              style={{ width: "100%" }}
            >
              <Input
                className="centered-input"
                placeholder="请输入成员昵称"
                autoComplete="off"
              />
            </Form.Item>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Form.Item
              name="phone_no"
              label="手机账户"
              rules={[
                { required: true, message: "请输入手机账户" },
                {
                  pattern: /^\d{11}$/,
                  message: "请输入11位数字的手机号",
                },
              ]}
              style={{ width: "100%" }}
            >
              <Input
                className="centered-input"
                placeholder="请输入手机账户"
                autoComplete="off"
              />
            </Form.Item>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Form.Item
              name="password"
              label="密码"
              rules={[{ required: true, message: "请输入密码" }]}
              style={{ width: "100%" }}
            >
              <Input
                className="centered-input"
                placeholder="请输入密码"
                autoComplete="off"
              />
            </Form.Item>
          </div>
          <Form.Item
            name="role_id"
            label="设置权限（只能选择一个）"
            rules={[{ required: true, message: "请选择一个权限" }]}
          >
            <Radio.Group style={{ display: "flex", justifyContent: "center" }}>
              <Radio value={"1"}>高级管理员</Radio>
              <Radio value={"2"}>智慧豆录入员</Radio>
              <Radio value={"3"}>智慧豆审核员</Radio>
              <Radio value={"4"}>智慧豆录入和审核员</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item style={{ textAlign: "center" }}>
            <Button type="primary" htmlType="submit">
              提交
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default CreateForm;
